import { useMemo } from "react";

import {
  defaultPageNumber as pageNumber,
  defaultPageSize as pageSize,
} from "@/constants/pagination";
import { CustomerSalesProductStatus } from "@/types/customer-sales-product.types";

import useGetAllCustomerSalesProducts from "./requests/customer-sales-product/use-get-all-customer-sales-product";

/**
 * Hook to check if user has active plans
 * @returns Object with active plans information
 */
export const useActivePlans = () => {
  const { data: customerSalesProduct, isLoading } = useGetAllCustomerSalesProducts({
    pageNumber,
    pageSize,
  });

  const plansInfo = useMemo(() => {
    if (isLoading || !customerSalesProduct?.items) {
      return {
        hasActivePlans: false,
        hasProducts: false,
        totalProducts: 0,
        activeProducts: 0,
        isLoading: true,
      };
    }

    const products = customerSalesProduct.items;
    const activeProducts = products.filter(
      (product) => product.status === CustomerSalesProductStatus.Active
    );

    return {
      hasActivePlans: activeProducts.length > 0,
      hasProducts: products.length > 0,
      totalProducts: products.length,
      activeProducts: activeProducts.length,
      isLoading: false,
      products,
      activeProductsList: activeProducts,
    };
  }, [customerSalesProduct, isLoading]);

  return plansInfo;
};

export default useActivePlans;
